import React, { useState, useCallback, useEffect } from 'react';
import { useDropzone } from 'react-dropzone';
import cl from './FileUploader.module.css'
import Remove from "../../../assets/Icon/Remove";
import { baseFileURL } from '../../../Api';

function FileUploader({ files, uploadFile, deleteFile,  title, disabled }) {
    const [isLoading, setIsLoading] = useState(false);

    const onDrop = async (acceptedFiles) => {
        setIsLoading(true);

   

        await uploadFile( acceptedFiles);

        setIsLoading(false);
    }

    useEffect(() => {
        if (!isLoading) {
        }
    }, [isLoading]);

    const handleDelete = (index) => {
        const fileToDelete = files[index];
        deleteFile(fileToDelete)
    };


    const { getRootProps, getInputProps } = useDropzone({
        onDrop,
        accept: '.jpg, .jpeg, .png, .pdf, .docx, .doc',
        noClick: disabled,
        noDrag: disabled,
    });


    const extractFileName = (path) => {
        const parts = path.split('/');
        return parts[parts.length - 1];
    };

    return (
        <div className={cl.boxUpload} >
            <div className={cl.title}>{title}</div>
            <div   {...getRootProps()} className={cl.clickDiv}>
                <input {...getInputProps()} />
                <div className={cl.message}>ჩააგდეთ ფაილები <br /><span>ან დააკლიკეთ</span></div>
            </div>
            <div className={cl.container}>
                {files.map((file, index) => (
                    <div key={index} className={cl.file}>
                        <a href={ baseFileURL + file} target="_blank" >
                            <p>{ extractFileName(file) }</p>
                        </a>
                         <span className={cl.dlt} onClick={() => handleDelete(index)}>
                            <Remove/>
                         </span>
                    </div>
                ))}
            </div>
            {isLoading && (
                <div className={cl.loadingoverlay}>
                    <div className={cl.loadingspinner}></div>
                </div>
            )}
        </div>
    );
}

export default FileUploader;